import { useEffect } from "react";

import { setOptionWriteGuardOptionId } from "./optionWriteGuardLink";

/**
 * Arms `optionWriteGuardLink` for as long as `optionId` is selected. Pass
 * `useOverlayOptionId()`, so the guard follows the design option flags.
 *
 * React runs child effects before parent effects, so arming only in an
 * effect left a window in which a child's effect could send a baseline
 * write. The id is therefore mirrored during render, before any child
 * renders or runs effects. Switching options never clears it in between:
 * only unmount disarms. The effect re-arms after Strict Mode's simulated
 * unmount.
 */
export const useOptionWriteGuard = (optionId: string | undefined): void => {
  setOptionWriteGuardOptionId(optionId);

  useEffect(() => {
    setOptionWriteGuardOptionId(optionId);
  }, [optionId]);

  useEffect(
    () => () => {
      setOptionWriteGuardOptionId(undefined);
    },
    []
  );
};
